<template>
  <span>{{ createdAt }}</span>
</template>

<script>
import DateFormatEnum from '~/enums/DateFormatEnum';
import moment from 'moment';
export default {
  name: "CreatedAtCell",
  props: {
    cellProps: Object,
    row: Object,
  },
  computed: {
    createdAt() {
      if (!('child_instance') in this.row) return '';
      return moment(this.row.child_instance.data.date).format(DateFormatEnum.DISPLAY_DATE);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
